export default {
  ENTRY: [
    { KEY: 0, TYPE: 'PRE_PAID', VALUE: 'Pré-Pago' },
    { KEY: 1, TYPE: 'POS_PAID', VALUE: 'Pós-Pago' },
    { KEY: 2, TYPE: 'ONLINE', VALUE: 'Online' },
    { KEY: 3, TYPE: 'EMPLOYEE', VALUE: 'Motorista' },
    { KEY: 4, TYPE: 'SELLING', VALUE: 'Rede de Venda' },
    { KEY: 5, TYPE: 'REQUISITION', VALUE: 'Requisição' },
    { KEY: 6, TYPE: 'FREE', VALUE: 'Gratuidade' },
    { KEY: 7, TYPE: '', VALUE: 'Rede de Venda - Emergencia' },
  ],
};
